<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="CustomerList"
          :extra-items="['顧客會員批次上傳']"  
        />
      </div>
    </div>
    <b-card>
      <div class="col-12 col-xl-6 d-flex align-items-center">
        <h4 class="mb-2 mb-xl-0 mr-2 font-weight-bold">顧客會員批次上傳</h4>
      </div>
      <div class="row my-3">
        <div class="col-12 col-xl-3">
          <div>請選擇通路</div>
          <b-form-select
            v-model="selectedMerchantID"
            :options="merchants"
            :disabled="isFetchMerchants"
          ></b-form-select>
          <div>上傳設定資料設定：</div>
          <b-form-checkbox v-model="isMobileSettingVerified">
            <span
              v-b-tooltip.hover.top="'有手機資料，才會設定已驗證'"
              class="d-inline-flex align-items-center">手機設定已驗證
              <span class="mdi mdi-help-circle-outline ml-1"></span>
            </span>
          </b-form-checkbox>
          <b-form-checkbox v-model="isRegistered">
            設定已註冊
          </b-form-checkbox>
        </div>
        <div class="col-12 col-xl-3 offset-1 d-flex align-items-center">
          <div class="row">
            <div class="col-12">請選擇會員識別欄位</div>
            <b-form-checkbox
              v-for="unique_by in uniqueByList"
              :key="unique_by.id"
              v-model="form.unique_by"
              :value="unique_by.id"
              class="mr-2"
            >
              {{ unique_by.name }}
            </b-form-checkbox>
          </div>
        </div>
        <div
          class="
            col-12 col-xl-4
            d-flex
            flex-column
            align-items-start align-items-xl-center
          "
        >
          <b-button variant="primary"
            @click="getSampleExcelFile(getModuleConfig('customer', 'sample_file.customer_import_xls') ,'/excel/customer_list.xlsx')"
                >下載範例檔案</b-button
          >
          <div class="row mt-2">
            <b-form-file
              id="fileInput"
              :key="fileInputKey"
              plain
              hidden
              @change="handleUploadFile"
              placeholder="尚未選擇檔案"
              browse-text="瀏覽"
            ></b-form-file>
            <b-button
              class="flex-shrink-0 mb-2 mb-xl-0"
              variant="primary"
              tag="label"
              for="fileInput"
            >
              請選擇檔案</b-button
            >
          </div>
          <b-button class="mt-2" variant="primary" @click="handleSubmitFile">確定上傳</b-button>
          <b-button v-if="results.failed.length > 0" class="mt-2" variant="primary" @click="exportFailedCustomers">下載失敗檔案</b-button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="accordion" role="tablist">
            <b-card
              no-body
              class="mb-1"
              v-for="(key, index) in Object.keys(results)"
              :key="index"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  v-if="key === 'failed'"
                  block
                  v-b-toggle.accordion-0
                  variant="info"
                  >失敗：{{ results.failed.length }}筆</b-button
                >
                <b-button
                  v-if="key === 'created'"
                  block
                  v-b-toggle.accordion-1
                  variant="info"
                  >新增：{{ results.created.length }}筆</b-button
                >
                <b-button
                  v-if="key === 'existed'"
                  block
                  v-b-toggle.accordion-2
                  variant="info"
                  >更新：{{ results.existed.length }}筆</b-button
                >
              </b-card-header>
              <b-collapse
                :id="`accordion-${index}`"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-table
                    striped
                    hover
                    responsive
                    :items="results[key]"
                    :fields="tableFields(key)"
                    :busy="isLoading"
                  >
                    <template #table-busy>
                      <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>
                  </b-table>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import customerApi from "../../../apis/customer";
import { getSampleExcelFile } from "@/utils/dashboardUtils";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { mapState, mapGetters } from "vuex";
import * as consts from "@/consts";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { BreadCrumb },
  data() {
    return {
      isFetchMerchants: false,
      isMobileSettingVerified: false,
      isRegistered: false,
      isLoading: false,
      selectedMerchantID: null,
      merchants: [{ value: null, text: "請選擇" }],
      form: {
        file: null,
        unique_by: [],
      },
      results: {
        failed: [],
        created: [],
        existed: [],
      },
      customers: [],
      uniqueByList: [
        { id: "mobile_phone", name: "手機" },
        { id: "birthday", name: "生日" },
        { id: "email", name: "Email" },
        { id: "outer_code", name: "Outer Code" },
      ],
      fields: [
        {
          key: "name",
          label: "顯示名稱",
        },
        {
          key: "outer_code",
          label: "會員外部編號",
        },
        {
          key: "mobile_phone",
          label: "手機",
        },
        {
          key: "email",
          label: "email",
        },
        {
          key: "birth",
          label: "生日",
        },
        {
          key: "sexual",
          label: "性別",
        },
        {
          key: "level_code",
          label: "會員等級代號",
        },
        {
          key: "level_name",
          label: "會員等級名稱",
        },
      ],
      fileInputKey: 0,
    };
  },

  computed: {
    ...mapGetters({
      getModuleConfigWithMerchant: "dashboardModule/getConfigWithMerchant",
    }),
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    tableFields() {
      return (key) => {
        let fields = [{key: "row", label: "第幾列", }, ...this.fields];
        if (key === 'failed') {
          fields = [...fields, { key: 'failed_reason', label: '失敗原因' }];
        }
        return fields;
      };
    }
  },

  created() {
    this.getMerchants();

    if (this.selectedMerchantID) {
      this.getCustomerList();
    }
  },

  watch: {
    "form.is_binded"() {
      this.getCustomerList();
    },
  },

  methods: {
    getSampleExcelFile,
    async getMerchants() {
      this.isFetchMerchants = true;
      const { data } = await customerApi.merchantList();
      this.isFetchMerchants = false;

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `${merchant.type_name} (${merchant.name})`
              : merchant.name,
          };
        }),
      ];

      const queryMerchantId = this.$route.query.merchant_hashid;
      if (queryMerchantId && this.merchants.find(m => m.value == queryMerchantId)) {
        this.selectedMerchantID = queryMerchantId;
      } else {
        const defaultMerchant = data.data?.find((merchant) => merchant.type === this.defaultMerchantType) ??
          data.data?.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE) ;
        this.selectedMerchantID = defaultMerchant?.id;
      }
    },

    handleBack() {
      this.$router.push({ name: "CustomerList" });
    },

    handleUploadFile(e) {
      const files = e.target.files;
      this.form.file = files && files.length ? files[0] : null;
      console.log("handleUploadFile", e, e.target.files);
    },

    async handleSubmitFile() {
      try {
        if (!this.selectedMerchantID) {
          this.$swal.fire({
            icon: "error",
            title: "請選擇通路",
          });
          return;
        }
        if (this.form.unique_by.length === 0) {
          this.$swal.fire({
            icon: "error",
            title: "請勾選會員識別欄位",
          });
          return;
        }
        this.isLoading = true;
        const fd = new FormData();
        fd.append("file", this.form.file);
        fd.append("unique_by", JSON.stringify(this.form.unique_by));
        fd.append("isMobileSettingVerified", this.isMobileSettingVerified ? 1 : 0);
        fd.append("isRegistered", this.isRegistered ? 1 : 0);

        const { data } = await customerApi.importCustomers(
          this.selectedMerchantID,
          fd
        );
        this.results = {
          failed: data.data.failed,
          created: data.data.created,
          existed: data.data.existed,
        }

        const moduleMapping = this.getModuleConfig('customer', 'sample_file.customer_import_xls.mapping');
        if (moduleMapping) {
          // 去替換掉如果有被覆蓋的內容
          moduleMapping.forEach((mapping) => {
            const field = this.fields?.find((field) => field.key == mapping.key);
            if (field) {
              field.label = mapping.text;
              field.key = mapping.text;
            } else {
              this.fields.push({
                key: mapping.text,
                label: mapping.text,
              });
            }
          });
        }
        this.fields.forEach((field) => {
            field.key = field.label;
        });
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.form.file = null;     // ⭐ 清掉舊 File reference
        this.fileInputKey++;       // ⭐ 強制重建 file input
        this.isLoading = false;
      }
    },
    async exportFailedCustomers() {
      try {
        let failed = this.results.failed;
        let params = {customers: failed};

        await customerApi.exportFailedCustomers(this.selectedMerchantID, params).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }
          });
        });
      } catch (e) {
        console.log(e)
      }
    },
    getModuleConfig(module, key) {
      return this.getModuleConfigWithMerchant(module, key, this.selectedMerchantID);
    },
  },
};
</script>

<style></style>
